<script>
    import { Doughnut } from 'vue-chartjs'

    export default {
        extends: Doughnut,
        props: ['data'],
        mounted() {
            this.renderChart({
                labels: ['Верификация', 'Участники инф. мероприятия', 'Кандидат', 'Архив'],
                datasets: [
                    {
                        backgroundColor: [
                            '#2eadd3',
                            '#ffc107',
                            '#4dbd74',
                            '#f5302e'
                        ],
                        data: this.data
                    }
                ]
            },
            {
                responsive: true,
                maintainAspectRatio: false,
            })
        }
    }
</script>
